// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Content_content__olQmx {
  width: 90%;
  padding-top: 24px;
  min-height: calc(100vh - var(--navbar-height));
}
@media only screen and (max-width: 480px) {
  .Content_content__olQmx {
    width: 95%;
    padding-top: 20px;
  }
}
@media only screen and (min-width: 481px) and (max-width: 1025px) {
  .Content_content__olQmx {
    width: 90%;
    min-height: 86.1904761905vh !important;
  }
}

.Content_content-institution-detail__gnlVX {
  max-width: none !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  width: 100%;
  min-height: calc(100vh - var(--navbar-height));
  overflow-y: hidden;
}
@media only screen and (min-width: 481px) and (max-width: 1025px) {
  .Content_content-institution-detail__gnlVX {
    height: 86.1904761905vh !important;
    min-height: 86.1904761905vh !important;
  }
}

.Content_content-homepage__YB7yi {
  max-width: none !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  width: 100%;
  min-height: calc(100vh - var(--navbar-height));
}

.Content_content-decoration__zJek0 {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  background-color: var(--background-color-2);
}

.Content_content-faculty__Cdt3A {
  padding-top: 24px;
  width: 100%;
  min-height: calc(100vh - var(--navbar-height));
}

.Content_content-faculty-detail__-FboT {
  max-width: none !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  width: 90% !important;
  padding-top: 40px;
  min-height: calc(100vh - var(--navbar-height));
}
@media only screen and (max-width: 480px) {
  .Content_content-faculty-detail__-FboT {
    width: 95% !important;
    padding-top: 30px;
  }
}
@media only screen and (min-width: 481px) and (max-width: 1025px) {
  .Content_content-faculty-detail__-FboT {
    width: 90% !important;
    min-height: 86.1904761905vh !important;
  }
}

.Content_content-unit__-TC7T {
  padding-top: 24px;
  width: 100%;
  min-height: calc(100vh - var(--navbar-height));
}
.Content_content-unit__-TC7T .Content_content-decoration__zJek0 {
  display: block;
}
.Content_content-unit__-TC7T .Content_content-container__LVbvg {
  position: relative;
}

.Content_content-unit-detail__qWbIz {
  max-width: none !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  min-height: calc(100vh - var(--navbar-height));
}
@media only screen and (max-width: 480px) {
  .Content_content-unit-detail__qWbIz {
    width: 95% !important;
    padding-top: 30px;
  }
}
@media only screen and (min-width: 481px) and (max-width: 1025px) {
  .Content_content-unit-detail__qWbIz {
    width: 90% !important;
    min-height: 86.1904761905vh !important;
  }
}

.Content_content-concept-detail__P-VT7 {
  width: 100%;
  min-height: calc(100vh - var(--navbar-height));
  max-width: none !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.Content_content-venue__rMrcl {
  padding-top: 24px;
  width: 100%;
  min-height: calc(100vh - var(--navbar-height));
}
.Content_content-venue__rMrcl .Content_content-decoration__zJek0 {
  display: block;
}
.Content_content-venue__rMrcl .Content_content-container__LVbvg {
  position: relative;
}

.Content_content-venue-detail__H07LK {
  width: 100%;
  min-height: calc(100vh - var(--navbar-height));
  max-width: none !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.Content_content-report__dLght,
.Content_content-collaborations__RcEpv {
  max-width: none !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  width: 100%;
  padding-top: 0;
  min-height: 0;
}

.Content_content-assistant__32ZlT {
  max-width: none !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  width: 100%;
  padding-top: 0;
  height: calc(100vh - 57px);
  max-height: calc(100vh - 57px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.Content_content-assistant__32ZlT.MuiContainer-root {
  height: 100%;
  padding: 0;
  margin: 0;
  max-width: none;
  overflow: hidden;
}
.Content_content-assistant__32ZlT div[class*=content-container] {
  width: 100%;
  height: 100%;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Layout/Content/Content.module.scss"],"names":[],"mappings":"AAqBA;EACE,UAAA;EACA,iBAAA;EACA,8CAAA;AApBF;AAsBE;EALF;IAMI,UAAA;IACA,iBAAA;EAnBF;AACF;AAqBE;EAVF;IAWI,UAAA;IACA,sCAAA;EAlBF;AACF;;AAqBA;EApCE,0BAAA;EACA,0BAAA;EACA,2BAAA;EAIA,WAAA;EACA,8CAAA;EAgCA,kBAAA;AAfF;AAiBE;EALF;IAMI,kCAAA;IACA,sCAAA;EAdF;AACF;;AAiBA;EA/CE,0BAAA;EACA,0BAAA;EACA,2BAAA;EAIA,WAAA;EACA,8CAAA;AA+BF;;AAcA;EACE,aAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EAEA,2CAAA;AAZF;;AAeA;EACE,iBAAA;EAzDA,WAAA;EACA,8CAAA;AA8CF;;AAgBA;EArEE,0BAAA;EACA,0BAAA;EACA,2BAAA;EAqEA,qBAAA;EACA,iBAAA;EACA,8CAAA;AAXF;AAaE;EANF;IAOI,qBAAA;IACA,iBAAA;EAVF;AACF;AAYE;EAXF;IAYI,qBAAA;IACA,sCAAA;EATF;AACF;;AAYA;EACE,iBAAA;EAjFA,WAAA;EACA,8CAAA;AAyEF;AArEE;EACE,cAAA;AAuEJ;AApEE;EACE,kBAAA;AAsEJ;;AAMA;EA5FE,0BAAA;EACA,0BAAA;EACA,2BAAA;EA8FA,8CAAA;AAHF;AAKE;EANF;IAOI,qBAAA;IACA,iBAAA;EAFF;AACF;AAIE;EAXF;IAYI,qBAAA;IACA,sCAAA;EADF;AACF;;AAIA;EAvGE,WAAA;EACA,8CAAA;EAPA,0BAAA;EACA,0BAAA;EACA,2BAAA;AA+GF;;AACA;EACE,iBAAA;EA7GA,WAAA;EACA,8CAAA;AAgHF;AA5GE;EACE,cAAA;AA8GJ;AA3GE;EACE,kBAAA;AA6GJ;;AALA;EAlHE,WAAA;EACA,8CAAA;EAPA,0BAAA;EACA,0BAAA;EACA,2BAAA;AAmIF;;AARA;;EA7HE,0BAAA;EACA,0BAAA;EACA,2BAAA;EA8HA,WAAA;EACA,cAAA;EACA,aAAA;AAaF;;AAVA;EArIE,0BAAA;EACA,0BAAA;EACA,2BAAA;EAqIA,WAAA;EACA,cAAA;EACA,0BAAA;EACA,8BAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAeF;AAbE;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;AAeJ;AAZE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAcJ","sourcesContent":["@mixin fill-width {\n  max-width: none !important;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n@mixin common-content {\n  width: 100%;\n  min-height: calc(100vh - var(--navbar-height));\n}\n\n@mixin include-decoration {\n  .content-decoration {\n    display: block;\n  }\n\n  .content-container {\n    position: relative;\n  }\n}\n\n.content {\n  width: 90%;\n  padding-top: 24px;\n  min-height: calc(100vh - var(--navbar-height));\n\n  @media only screen and (max-width: 480px) {\n    width: 95%;\n    padding-top: 20px;\n  }\n\n  @media only screen and (min-width: 481px) and (max-width: 1025px) {\n    width: 90%;\n    min-height: calc(100vh - 290vh / 21) !important;\n  }\n}\n\n.content-institution-detail {\n  @include fill-width;\n  @include common-content;\n  overflow-y: hidden;\n\n  @media only screen and (min-width: 481px) and (max-width: 1025px) {\n    height: calc(100vh - 290vh / 21) !important;\n    min-height: calc(100vh - 290vh / 21) !important;\n  }\n}\n\n.content-homepage {\n  @include fill-width;\n  @include common-content;\n}\n\n.content-decoration {\n  display: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  // height: 200px;\n  background-color: var(--background-color-2);\n}\n\n.content-faculty {\n  padding-top: 24px;\n  // max-width: none !important;\n  @include common-content;\n  // @include include-decoration;\n}\n\n.content-faculty-detail {\n  @include fill-width;\n  width: 90% !important;\n  padding-top: 40px;\n  min-height: calc(100vh - var(--navbar-height));\n\n  @media only screen and (max-width: 480px) {\n    width: 95% !important;\n    padding-top: 30px;\n  }\n\n  @media only screen and (min-width: 481px) and (max-width: 1025px) {\n    width: 90% !important;\n    min-height: calc(100vh - 290vh / 21) !important;\n  }\n}\n\n.content-unit {\n  padding-top: 24px;\n  @include common-content;\n  @include include-decoration;\n}\n\n.content-unit-detail {\n  @include fill-width;\n  // width: 90% !important;\n  // padding-top: 40px;\n  min-height: calc(100vh - var(--navbar-height));\n\n  @media only screen and (max-width: 480px) {\n    width: 95% !important;\n    padding-top: 30px;\n  }\n\n  @media only screen and (min-width: 481px) and (max-width: 1025px) {\n    width: 90% !important;\n    min-height: calc(100vh - 290vh / 21) !important;\n  }\n}\n\n.content-concept-detail {\n  @include common-content;\n  @include fill-width;\n}\n\n.content-venue {\n  padding-top: 24px;\n  @include common-content;\n  @include include-decoration;\n}\n\n.content-venue-detail {\n  @include common-content;\n  @include fill-width;\n}\n\n.content-report,\n.content-collaborations {\n  @include fill-width;\n  width: 100%;\n  padding-top: 0;\n  min-height: 0;\n}\n\n.content-assistant {\n  @include fill-width;\n  width: 100%;\n  padding-top: 0;\n  height: calc(100vh - 57px);\n  max-height: calc(100vh - 57px);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n\n  &:global(.MuiContainer-root) {\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    max-width: none;\n    overflow: hidden;\n  }\n\n  div[class*='content-container'] {\n    width: 100%;\n    height: 100%;\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `Content_content__olQmx`,
	"content-institution-detail": `Content_content-institution-detail__gnlVX`,
	"content-homepage": `Content_content-homepage__YB7yi`,
	"content-decoration": `Content_content-decoration__zJek0`,
	"content-faculty": `Content_content-faculty__Cdt3A`,
	"content-faculty-detail": `Content_content-faculty-detail__-FboT`,
	"content-unit": `Content_content-unit__-TC7T`,
	"content-container": `Content_content-container__LVbvg`,
	"content-unit-detail": `Content_content-unit-detail__qWbIz`,
	"content-concept-detail": `Content_content-concept-detail__P-VT7`,
	"content-venue": `Content_content-venue__rMrcl`,
	"content-venue-detail": `Content_content-venue-detail__H07LK`,
	"content-report": `Content_content-report__dLght`,
	"content-collaborations": `Content_content-collaborations__RcEpv`,
	"content-assistant": `Content_content-assistant__32ZlT`
};
export default ___CSS_LOADER_EXPORT___;
